import React, {Component} from 'react';
import {Form, Modal, Button,message,Input} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import API from '@/API/api';
import {editCateItemAPI} from '@/API';
const FormItem = Form.Item;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class EditItemModal extends Component{
	
	state={
		btnLoading:false
	}
	componentDidMount(){
		
	}

	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
	        this.setState({btnLoading:true})
	        let postForm={
	        		"cateitem_id":this.props.itemData.cateitem_id,
	        		"cateitem":values.cateitem
	        }
			editCateItemAPI(postForm).then(res=>{
				message.success('保存成功！');
		      	this.setState({btnLoading:false})
		      	this.props.handleClose()
		      	this.props.form.resetFields();
			})
           
	      }
	    });
	 }


	
	render(){
		let {btnLoading}=this.state
		let {editDialog,handleClose,itemData}=this.props

		const { getFieldDecorator } = this.props.form;

		
		return(
			<Modal
	          title="字词编辑"
	          visible={editDialog}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>保存</Button>,
	          ]}
	        >
				<Form >
					<FormItem {...formItemLayout} label={itemData.group[0]} hasFeedback>
						{getFieldDecorator(`cateitem`,{
							rules: [{ type: 'string',required: true, message: '必填项！', whitespace: true }],
							initialValue:itemData.cateitem
						})(<TextArea style={{width:'100%'}} rows={3} /> )}
					</FormItem>
				</Form >
			 </Modal>
		)
	}
}


export const WrappedEditItemModalForm = Form.create()(EditItemModal)



// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/wordBank/modal/edit_item.js